import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TaskFormComponent from '../components/TaskForm';
import api from '../services/api';

export default function TaskFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo;
  const [error, setError] = useState(null);
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(!!id);

  useEffect(() => {
    const loadTask = async () => {
      if (id) {
        try {
          const { data } = await api.get(`/tasks/${id}`);
          setTask(data);
        } catch (err) {
          setError(err.response?.data?.error || 'Failed to load task');
        } finally {
          setLoading(false);
        }
      }
    };

    loadTask();
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      if (id) {
        await api.put(`/tasks/${id}`, formData);
      } else {
        await api.post('/tasks', formData);
      }
      navigate(id && returnTo ? returnTo : '/tasks', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save task');
    }
  };

  return (
    <div className="task-form-page">
      <div className="header">
        {/* <button 
            className="back-btn"
            onClick={() => navigate('/tasks')}
          >
            ←  Tasks
          </button> */}
        <div className="header-content">
          <h2>{id ? 'Edit Task' : 'Create New Task'}</h2>
        </div>
      </div>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      <div className="form-container">
        {loading ? (
          <div>Loading task details...</div>
        ) : (
          <TaskFormComponent
            task={task}
            onSubmit={handleSubmit}
            onCancel={() => navigate(returnTo || '/tasks')}
          />
        )}
      </div>

      <style jsx>{`
        .task-form-page {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .header {
          background: #fff;
          border-bottom: 1px solid #eee;
          margin: -20px -20px 20px;
          padding: 20px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .header-content {
          max-width: 800px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header h2 {
          margin: 0;
          color: #172B4D;
          font-size: 24px;
        }

       

        .back-button:hover {
          background: #F4F5F7;
        }

        .error-banner {
          background: #FFEBE6;
          color: #DE350B;
          padding: 12px 16px;
          border-radius: 3px;
          margin-bottom: 20px;
          text-align: center;
        }

        .form-container {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          padding: 24px;
          max-width: 800px;
          margin: 0 auto;
        }
      `}</style>
    </div>
  );
}
